import { render, staticRenderFns } from "./JlLogin.vue?vue&type=template&id=5faaf1fc&scoped=true&"
import script from "./JlLogin.vue?vue&type=script&lang=js&"
export * from "./JlLogin.vue?vue&type=script&lang=js&"
import style0 from "./JlLogin.vue?vue&type=style&index=0&id=5faaf1fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faaf1fc",
  null
  
)

export default component.exports